// extracted by mini-css-extract-plugin
export var divider = "_rg-0";
export var systemMessage = "_rg-1";
export var systemMessageWrapper = "_rg-2";